import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree,} from '@angular/router';
import {Observable} from 'rxjs';
import {UserService} from '../login/user.service';

@Injectable({
  providedIn: 'root',
})
export class IsUserGuard implements CanActivate {
  constructor(private readonly auth: UserService, private readonly router: Router) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (
      this.auth.isLoggedIn
    ) {
      return true;
    } else {
      this.auth.logout();
      this.router.navigate(['/login']);
      return false;
    }
  }
}
